module.exports = __webpack_public_path__ + "static/media/bannerWingsStop.662c2234.jpg";